import React, { useState } from 'react';
import { toast } from 'react-toastify';

import { Form, FloatingLabel } from '../../../components/form';
import { Button } from '../../../components/general';
import { ConfirmModal } from '../../../components/modals';

import { sendMsNotification } from '../../../services/api/emails';

const HelpForm = () => {
  const [data, setData] = useState({ name: '', email: '', requestText: '' });
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSubmit = async () => {
    setIsLoading(true);

    const text =
      'You have a new <b>Support Request</b> from the following user:<br />' +
      `<b>User</b>: ${data.email}<br />` +
      `<b>Name</b>: ${data.name}<br /><br />` +
      data.requestText;

    const isSuccess = await sendMsNotification(
      'Support Request',
      text.replace(/\n/g, '<br />'),
      ['naomi@crowdclip.com'],
    );

    if (isSuccess) setShowConfirmModal(true);
    else toast.error('Something went wrong. Try again later');

    setIsLoading(false);
  };

  return (
    <React.Fragment>
      <div className="flex flex-col p-4 gap-4 bg-grey-100 rounded-md">
        <h2 className="text-center">Support Request Form</h2>

        <div>
          We're here to help whenever you encounter an issue or have questions.
          Complete the Support Request Form to contact the CrowdClip&reg;
          support team and we will endeavour to assist you within 48 hours.
        </div>

        <Form onSubmit={handleSubmit} disabled={isLoading}>
          <FloatingLabel
            label="Name"
            name="name"
            value={data.name}
            onChange={handleChange}
            required
          />

          <FloatingLabel
            label="Email"
            type="email"
            name="email"
            value={data.email}
            onChange={handleChange}
            required
          />

          <FloatingLabel
            label="How can we help?"
            as="textarea"
            name="requestText"
            value={data.requestText}
            onChange={handleChange}
            required
          />

          <Button
            className="w-full sm:w-1/2 self-center"
            disabled={
              data.name === '' || data.email === '' || data.requestText === ''
            }
            isSubmitBtn
            isProcessing={isLoading}
          >
            Submit
          </Button>
        </Form>
      </div>

      <ConfirmModal
        show={showConfirmModal}
        onHide={() => setShowConfirmModal(false)}
        heading="Thank you, our team will contact you shortly!"
      />
    </React.Fragment>
  );
};

export default HelpForm;
